/**
 * Is it running in a browser?
 * @returns
 */
var isBrowser = function () { return typeof window !== 'undefined'; };
export default isBrowser;
